let apiUrl;

switch (process.env.REACT_APP_ENV) {
	default:
	case "development":
		//apiUrl = "https://localhost:7209";
		apiUrl = "https://api.vlfsportsperformance.it";
		break;
	case "test":
		//apiUrl = "https://localhost:7209";
		apiUrl = "https://api.ligornalab.it";
		break;
	case "production":
		apiUrl = "https://api.goalplayerslab.it";
		break;
}
export default apiUrl;
